import { Typography, theme } from "antd";
import { Link } from "react-router-dom";
import logoBlack from "../../../img/logo_black.png";
import logoGreen from "../../../img/logo_green.png";
import logoWhite from "../../../img/logo_white.png";

const { Title } = Typography;
const { useToken } = theme;

const Logo = ({
	iconSize = 24,
	titleLevel = 3,
	showText = true,
	showIcon = true,
	hyperlink = true,
	imageUrl,
	showPointer = false,
}) => {
	const { token } = useToken();

	const logoImage = imageUrl || logoWhite;
	const icon = showIcon && (
		<img
			src={logoImage}
			alt={Logo.APP_NAME}
			style={{ height: `${iconSize}px`, display: "block" }}
		/>
	);

	const text = showText && (
		<Title
			level={titleLevel}
			style={{ margin: 0, color: token.colorPrimary, fontSize: iconSize * 0.9 }}
		>
			{Logo.APP_NAME}
		</Title>
	);

	const content = (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				gap: "8px",
				whiteSpace: "nowrap",
				cursor: hyperlink || showPointer ? "pointer" : "default",
				justifyContent: showText ? "flex-start" : "center",
			}}
		>
			{icon}
			{text}
		</div>
	);

	return hyperlink ? (
		<Link to="/" style={{ textDecoration: "none" }}>
			{content}
		</Link>
	) : (
		content
	);
};

Logo.APP_NAME = "BodhiStreams";
Logo.FAVICON_URL = logoWhite;
Logo.logoWhite = logoWhite;
Logo.logoBlack = logoBlack;
Logo.logoGreen = logoGreen;

// Static methods to return different logo variations
Logo.SiteName = ({
	hyperlink = false,
	level = 3,
	fontSize = 24,
	showPointer = false,
}) => (
	<Logo
		showText={true}
		showIcon={false}
		hyperlink={hyperlink}
		titleLevel={level}
		iconSize={fontSize}
		showPointer={showPointer}
	/>
);

Logo.Image = ({ hyperlink = false, size = 24, showPointer = false }) => (
	<Logo
		showText={false}
		showIcon={false}
		hyperlink={hyperlink}
		iconSize={size}
		showPointer={showPointer}
	/>
);

Logo.Favicon = ({
	hyperlink = false,
	size = 24,
	showPointer = false,
	imageUrl,
}) => (
	<Logo
		showText={false}
		showIcon={true}
		hyperlink={hyperlink}
		iconSize={size}
		showPointer={showPointer}
		imageUrl={imageUrl}
	/>
);

Logo.Full = ({ hyperlink = false, size = 24, showPointer = false }) => (
	<Logo
		showText={true}
		showIcon={false}
		hyperlink={hyperlink}
		iconSize={size}
		showPointer={showPointer}
	/>
);

Logo.IconText = ({
	hyperlink = false,
	size = 24,
	level = 3,
	showPointer = false,
	imageUrl,
}) => (
	<Logo
		showText={true}
		showIcon={true}
		hyperlink={hyperlink}
		iconSize={size}
		titleLevel={level}
		showPointer={showPointer}
		imageUrl={imageUrl}
	/>
);

export default Logo;
